module.exports = __webpack_public_path__ + "img/0383bdf.jpg";